import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject } from 'rxjs';
import { TechnicalViewService } from 'src/app/_services/technical-view.service';
import { VehiclesService } from 'src/app/_services/vehicles.service';
import { FormComponent } from '../../components/form/form.component';
import { CreateVehicleComponent } from './create-vehicle/create-vehicle.component';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { ArchiveComponent } from '../archive/archive.component';

@Component({
  selector: 'app-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styleUrls: ['./vehicle-details.component.scss'],
})
export class VehicleDetailsComponent implements OnInit {
  selectedRowCMObservable$: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  Vehicles$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  ref: DynamicDialogRef | undefined;
  selectedVehicle: any;
  vehicles$ = this.vehiclesService.vehiclesObservable;
  archivedVehicles$ = this.vehiclesService.archivedVehiclesObservable;
  @ViewChild('dt') dt: Table | undefined;
  @ViewChild('archivedDt') archivedDt: Table | undefined;
  vehicleSearch = '';
  archivedSearch = '';

  constructor(
    public dialogService: DialogService,
    public vehiclesService: VehiclesService,
    public technicalViewService: TechnicalViewService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    let vehiclesLoaded = false;
    let archivedLoaded = false;
    const checkDone = () => {
      if (vehiclesLoaded && archivedLoaded) {
        this.Vehicles$.next(false);
      }
    };

    this.vehiclesService.getAllVehicles().subscribe({
      next: (data) => {
        this.vehiclesService.updateVehicles(data.body);
        vehiclesLoaded = true;
        checkDone();
      },
      error: () => {
        vehiclesLoaded = true;
        checkDone();
      },
    });

    this.vehiclesService.getArchivedVehicles().subscribe({
      next: (data) => {
        this.vehiclesService.updateArchivedVehicles(data.body);
        archivedLoaded = true;
        checkDone();
      },
      error: () => {
        archivedLoaded = true;
        checkDone();
      },
    });
  }

  filterGlobal(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.vehicleSearch = inputElement.value;
    this.dt?.filterGlobal(this.vehicleSearch, 'contains');
  }

  filterArchivedGlobal(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.archivedSearch = inputElement.value;
    this.archivedDt?.filterGlobal(this.archivedSearch, 'contains');
  }

  clearVehicleSearch() {
    this.vehicleSearch = '';
    this.dt?.clear();
  }

  clearArchivedSearch() {
    this.archivedSearch = '';
    this.archivedDt?.clear();
  }

  selectVehicle(vehicle: any) {
    this.vehiclesService.selectedVehicle = vehicle;
    // console.log('selected vehicle', vehicle);
    // save selected vehicle to local storage
    localStorage.setItem('selectedVehicle', JSON.stringify(vehicle));
    // navigate to technical view page
    this.router.navigate(['/technical']);
  }

  // ---------------------------- Table actions ---------------------------- //
  columns = [
    { field: 'vehicle_reference', header: 'Vehicle Reference ID' },
    { field: 'engine_no', header: 'Vehicle Engine Number' },
    { field: 'chassis_no', header: 'Vehicle Chasis Number' },
    { field: 'model', header: 'Vehicle Model' },
    { field: 'year_model', header: 'Year Model' },
    { field: 'date_inservice', header: 'Vehicle Date In Service' },
    { field: 'service_interval', header: 'Vehicle Service Interval' },
  ];

  storeRowDetail(rowData: any) {
    this.selectedVehicle = rowData;
  }

  items: MenuItem[] = [
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      command: () => this.showEdit(this.selectedVehicle),
    },
    {
      label: 'Archive',
      icon: 'pi pi-book',
      command: () => this.showArchive(this.selectedVehicle),
    },
    {
      label: 'Delete',
      icon: 'pi pi-trash',
      command: () => this.deleteVehicle(this.selectedVehicle),
    },
  ];

  archivedOptions: MenuItem[] = [
    {
      label: 'Delete',
      icon: 'pi pi-trash',
      command: () => this.deleteVehicle(this.selectedVehicle),
    },
  ];

  showEdit($event: any) {
    // console.log('row', $event);
    let row = $event;
    this.ref = this.dialogService.open(FormComponent, {
      data: {
        formdata: row,
      },
      header: 'Edit Vehicle',
      width: '75%',
      closeOnEscape: true,
    });
  }

  showArchive($event: any) {
    let row = $event;
    this.ref = this.dialogService.open(ArchiveComponent, {
      data: {
        formdata: row,
      },
      header: 'Archive Vehicle',
      width: '75%',
      styleClass: 'archive-vehicle-dialog-shell',
      closeOnEscape: true,
    });
  }

  showAdd($event: any) {
    let vehicle = $event;
    this.ref = this.dialogService.open(CreateVehicleComponent, {
      data: {
        vehicleData: vehicle,
      },
      header: 'Add Vehicle',
      width: '75%',
      styleClass: 'update-record-dialog-shell',
      closeOnEscape: true,
    });
    this.ref.onClose.subscribe((result) => {
      if (result) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Vehicle added successfully',
          key: 'vehicles',
        });
      }
    });
  }

  deleteVehicle(rowData: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this vehicle?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.vehiclesService.deleteVehicle(rowData.id).subscribe({
          next: () => {
            this.vehiclesService.getAllVehicles().subscribe((data) => {
              this.vehiclesService.updateVehicles(data.body);
            });

            this.vehiclesService.getArchivedVehicles().subscribe((data) => {
              this.vehiclesService.updateArchivedVehicles(data.body);
            });

            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Vehicle deleted successfully',
              key: 'vehicles',
            });
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to delete vehicle',
              key: 'vehicles',
            });
          },
        });
      },
    });
  }
}
